import { render } from "./NodrizaTable.vue?vue&type=template&id=80385ed2"
import script from "./NodrizaTable.vue?vue&type=script&lang=js"
export * from "./NodrizaTable.vue?vue&type=script&lang=js"

import "./NodrizaTable.vue?vue&type=style&index=0&id=80385ed2&lang=scss"

import exportComponent from "/home/runner/work/tribuk-ui/tribuk-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__